/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/array-type */
/* eslint-disable @typescript-eslint/no-unused-vars */
import {ExclamationOutlined, SearchOutlined} from '@ant-design/icons';
import type {InputRef} from 'antd';
import {Button, Input, Table as TableAnt, Tag} from 'antd';
import {ColumnType, ColumnsType} from 'antd/es/table';
import React, {useContext, useEffect, useMemo, useRef, useState} from 'react';

import {TF} from '../../constants/Common';
import FilteredUnit from '../../constants/FilteredUnit';
import InformativeText from '../../constants/InformativeText';
import {SampleExcel} from '../../constants/SampleExcel';
import {ISelect} from '../../interface/ISelect';
import SelectedCountryContext from '../../pages/configurator/orgFacility/Constants/SelectedCountryContext';
import {statusEm} from '../../pages/netZero/utils/commonFunctions';
import {uploadTypes} from '../../services/constants/uploadTypes';
import {APITypeEnum} from '../../services/interface/tableAPIType';
import fugitiveAPI from '../../services/modules/IP/fugitiveAPI';
import emissionSourceJSON from '../../services/modules/JSON/emissionSource';
import frequencyJSON from '../../services/modules/JSON/frequency';
import refrigerantTypeJSON from '../../services/modules/JSON/refrigentType';
import refrigerantUsed from '../../services/modules/JSON/refriUsed';
import usePlatformStore from '../../store/platformStore/platformStore';
import useJSONStore from '../../store/StaticJson/jsonStore';
import {
  getStatusColor,
  hasUserRole,
  hasViewRole,
  UserRole
} from '../../utils/commonFunctions';
import {formatIndian} from '../../utils/formatIndian';
import mapAndFilter from '../../utils/mapCountry';
import {shouldBlockReadOnly} from '../../utils/SubscriptionHelper';
import DisplayModal from '../DisplayModal/DisplayModal';
import {objTypes} from '../DrawerForm/Constants/commonConstants';
import AllDataInfo from '../DrawerForm/Utils/AllDataInfo';
import DrawerForm from '../DrawerForm/Utils/DrawerForm';
import {
  facilityKeyLabel,
  yearKeyLabel
} from '../Forms/Constants/IP/commonKeyLabel';
import {RefriKey, RefriLabel} from '../Forms/Constants/IP/RefriKeyLabel';
import RefriForm from '../Forms/RefriForm';
import {
  checkerStatusKey,
  checkerStatusLabel
} from '../Forms/Utils/checkerStatusKeyLabel';
import JobsModal from '../Jobs/JobsModal';
import Loader from '../Loader/Loader';

import {FullInfo, makeCheckKeyLabel, Title} from './Constants/Common';
import {defaultCol} from './Interface/ITable';
import ActionsButton from './Utils/ActionsButton';
import TableTitleHeader from './Utils/TableTitleHeader';
import TimeFrameDataTooltip from './Utils/TimeFrameDataTooltip';

const FugitiveEmission: React.FC<{
  selectedYear: string;
  facilityId: string;
}> = ({selectedYear, facilityId}) => {
  interface DataType {
    key: React.Key;
    _id: string;
    emissionSource: number;
    numberOfUnit: number;
    refrigerantUsed: number;
    frequency: number;
    frequencyNo: number;
    quantity: number;
    comment: string;
  }

  const [dataSource, setDataSource] = useState<DataType[]>([]);

  const [showModel, setShowModel] = useState(false);
  const [showJobs, setShowJobs] = useState(false);
  const [editData, setEditData] = useState<any>();
  const [isEdit, setIsEdit] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState<any[]>([]);
  const [refresh, setRefresh] = useState(false);
  const [isRefresh, setIsRefresh] = useState(false);
  const [allJSON, setAllJSON] = useState(false);
  const [openDisplayModal, setOpenDisplayModal] = useState(false);
  const [openDisplayModalData, setOpenDisplayModalData] = useState({});
  const [openDisplayModalType, setOpenDisplayModalType] = useState({
    title: '',
    dataKey: ''
  });

  const [facilityEfdb, setFacilityEfdb] = useState<any>({});

  const [showModelInfo, setShowModelInfo] = useState(false);
  const {selectedCountry, efdbData} = useContext(SelectedCountryContext);

  useEffect(() => {
    if (!facilityId || !selectedYear) {
      setDataSource([]);
    }
    if (facilityId && selectedYear && allJSON) {
      setIsRefresh(true);
      fugitiveAPI(
        APITypeEnum.GET_ALL,
        undefined,
        `${facilityId}/${selectedYear}`
      )
        .then((res) => {
          setDataSource(res ?? []);
          setFacilityEfdb(
            efdbData?.[selectedYear]?.find((i: any) => {
              return i.facilityId === facilityId;
            })
          );
        })
        .catch(() => {
          setDataSource([]);
        })
        .finally(() => {
          setIsRefresh(false);
        });
    }
  }, [facilityId, selectedYear, allJSON]);

  useEffect(() => {
    // setIsRefresh(true);
    Promise.all([
      emissionSourceJSON(),
      refrigerantTypeJSON(),
      frequencyJSON(),
      refrigerantUsed()
    ])
      .catch(() => {})
      .finally(() => {
        // setIsRefresh(false);
        setAllJSON(true);
      });
  }, []);

  useEffect(() => {
    if (refresh) {
      setIsRefresh(true);
      fugitiveAPI(
        APITypeEnum.GET_ALL,
        undefined,
        `${facilityId}/${selectedYear}`
      )
        .then((res) => {
          setDataSource(res ?? []);
        })
        .catch(() => {
          setDataSource([]);
        })
        .finally(() => {
          setIsRefresh(false);
          setRefresh(false);
        });
    }
  }, [refresh]);

  const handleDelete = (_id: string[] | string) => {
    fugitiveAPI(APITypeEnum.DELETE_ALL, {
      refrigerants: _id
    })
      .then(() => {
        setSelectedRowKeys([]);
        setRefresh(true);
      })
      .catch(() => {});
  };

  const {emissionSource, frequency} = useJSONStore.getState();
  const refridgentUsed = useJSONStore
    .getState()
    .refridgentUsed.filter((item) => item?.dbName === facilityEfdb?.scope1);

  const fugitiveKeyLabel = [
    {
      key: yearKeyLabel.key,
      label: yearKeyLabel.label,
      type: objTypes.string
    },
    {
      key: facilityKeyLabel.key,
      label: facilityKeyLabel.label,
      type: objTypes.facilityFormPreview,
      relatedKey: yearKeyLabel.key,
      isMaker: hasUserRole(UserRole.Maker_Role)
    },
    {
      key: RefriKey.EMISSION_SOURCE,
      label: RefriLabel.EMISSION_SOURCE,
      type: objTypes.json,
      format: emissionSource
    },
    {
      key: RefriKey.NO_UNITS,
      label: RefriLabel.NO_UNITS,
      type: objTypes.number
    },
    {
      key: RefriKey.DATE_INSTALLATION,
      label: RefriLabel.DATE_INSTALLATION,
      type: objTypes.date,
      format: 'DD-MM-YYYY'
    },
    {
      key: RefriKey.REFRI_USED,
      label: RefriLabel.REFRI_USED,
      type: objTypes.json,
      format: refridgentUsed
    },
    {
      key: RefriKey.FREQUENCY_INSPE,
      label: RefriLabel.FREQUENCY_INSPE,
      type: objTypes.json,
      format: frequency
    },
    {
      key: RefriKey.FREQUENCY_NO,
      label: RefriLabel.FREQUENCY_NO,
      type: objTypes.number
    },
    {
      key: RefriKey.REFRI_CHARGE,
      label: RefriLabel.REFRI_CHARGE,
      type: objTypes.number,
      unit: FilteredUnit(selectedCountry).weight
    },
    // {
    //   key: TF,
    //   label: RefriLabel.QUANTITY_TF,
    //   type: objTypes.timeFrameData,
    //   renderType: 'multi'
    // },
    ...(hasUserRole(UserRole.Checker_Role) ||
    hasUserRole(UserRole.Both_role) ||
    !hasUserRole(UserRole.Company_Admin)
      ? [
          {
            key: checkerStatusKey.STATUS,
            label: checkerStatusLabel.STATUS,
            type: objTypes.status
          },
          {
            key: checkerStatusKey.COMMENT,
            label: checkerStatusLabel.COMMENT,
            type: objTypes.comment
          }
        ]
      : [])
  ];

  const sorter = (key: keyof DataType) => {
    return {
      sorter: (a: DataType, b: DataType) => {
        const valueA = a[key];
        const valueB = b[key];
        if (typeof valueA === 'number' && typeof valueB === 'number') {
          return valueA - valueB;
        } else if (typeof valueA === 'string' && typeof valueB === 'string') {
          return valueA.localeCompare(valueB);
        }

        return 0;
      }
    };
  };

  const searchInput = useRef<InputRef>(null);

  const SearchFilter = (
    title: string,
    dataIndex: keyof any,
    option: ISelect[] | undefined = undefined
  ): defaultCol & ColumnType<any> => {
    return {
      filterDropdown: ({selectedKeys, setSelectedKeys, confirm}) => {
        return (
          <div
            style={{padding: 8}}
            onKeyDown={(e) => {
              e.stopPropagation();
            }}
          >
            <Input
              ref={searchInput}
              value={selectedKeys[0]}
              placeholder={`Search ${title}`}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
              }}
              onPressEnter={() => {
                confirm();
              }}
              onBlur={() => {
                confirm();
              }}
              allowClear
            />
          </div>
        );
      },
      filterIcon: <SearchOutlined />,
      onFilter: (value, record) => {
        if (option) {
          const filtered = option.filter((item) => {
            if (typeof item?.label === 'string') {
              return item?.label
                .toString()
                .toLowerCase()
                .includes(value.toString().toLowerCase());
            } else {
              return [];
            }
          });

          return filtered?.some((item) => {
            return item?.value === record[dataIndex];
          });
        } else {
          return record[dataIndex]
            ?.toString()
            .toLowerCase()
            .includes(value?.toString().toLowerCase());
        }
      },
      onFilterDropdownOpenChange: (visible) => {
        if (visible) {
          setTimeout(() => searchInput.current?.select(), 100);
        }
      }
    };
  };

  const columns: (defaultCol & ColumnsType<DataType>[0])[] = useMemo(() => {
    return [
      {
        title: RefriLabel.EMISSION_SOURCE,
        dataIndex: RefriKey.EMISSION_SOURCE,
        editable: true,
        type: 'select',
        ...SearchFilter(
          RefriLabel.EMISSION_SOURCE,
          RefriKey.EMISSION_SOURCE,
          emissionSource
        ),
        render: (value: any) => {
          return (
            <>
              {
                emissionSource?.find((item) => {
                  return item.value === value;
                })?.label
              }
            </>
          );
        }
      },
      {
        title: RefriLabel.NO_UNITS,
        dataIndex: RefriKey.NO_UNITS,
        // width: '120px',
        editable: true,
        type: 'number',
        render: (value) => {
          return formatIndian(value);
        }
      },

      {
        title: RefriLabel.REFRI_USED,
        dataIndex: RefriKey.REFRI_USED,
        editable: true,
        type: 'select',
        ...SearchFilter(
          RefriLabel.REFRI_USED,
          RefriKey.REFRI_USED,
          refridgentUsed
        ),
        render: (value) => {
          return (
            <>
              {
                refridgentUsed?.find((item) => {
                  return (
                    item?.value === value &&
                    item?.dbName === facilityEfdb?.scope1
                  );
                })?.label
              }
            </>
          );
        }
      },
      {
        title: RefriLabel.FREQUENCY_INSPE,
        dataIndex: RefriKey.FREQUENCY_INSPE,
        editable: true,
        type: 'select',
        filterer: frequency,
        filters: frequency.map((item) => {
          return {text: item?.label, value: item?.value};
        }),
        onFilter: (value, record) => {
          return record[RefriKey.FREQUENCY_INSPE as keyof DataType] === value;
        },
        render: (value) => {
          return (
            <>
              {frequency?.find((item) => {
                return item?.value === value;
              })?.label ?? '-'}
            </>
          );
        }
      },
      {
        title: RefriLabel.FREQUENCY_NO,
        dataIndex: RefriKey.FREQUENCY_NO,
        editable: true,
        type: 'number',
        render: (value) => {
          return formatIndian(value);
        }
        // width: '100px'
      },
      // {
      //   title: RefriLabel.QUANTITY_TF,
      //   dataIndex: TF,
      //   editable: true,
      //   type: 'select',
      //   // render: (value) => {
      //   //   return <TimeFrameRender value={value} dataKey={RefriKey.QUANTITY_TF} />;
      //   // }
      //   render: (value) => {
      //     const mainData = value?.find((item: any) => {
      //       return item.type === RefriKey.QUANTITY_TF;
      //     });

      //     return (
      //       <div
      //         onClick={() => {
      //           setOpenDisplayModal(true);
      //           setOpenDisplayModalData(mainData);
      //           setOpenDisplayModalType({
      //             title: RefriLabel.QUANTITY_TF,
      //             dataKey: RefriKey.QUANTITY_TF
      //           });
      //         }}
      //         style={{
      //           textDecorationLine: 'underline',
      //           pointerEvents: 'auto',
      //           cursor: 'pointer'
      //         }}
      //       >
      //         <div>{`${String(formatIndian(sumValue(mainData.data)))} ${
      //           FilteredUnit(selectedCountry).weight
      //         }`}</div>
      //       </div>
      //     );
      //   }
      // },
      {
        title: RefriLabel.REFRI_CHARGE,
        dataIndex: RefriKey.REFRI_CHARGE,
        //   width: '120px',
        editable: true,
        type: 'number',
        render: (value) => {
          return value
            ? `${formatIndian(value)} ${FilteredUnit(selectedCountry).weight}`
            : '-';
        }
      },
      ...(hasUserRole(UserRole.Maker_Role) ||
      hasUserRole(UserRole.Both_role) ||
      hasViewRole(UserRole.View_Only)
        ? [
            {
              title: makeCheckKeyLabel.STATUS_COMMENTS.label,
              dataIndex: 'status',
              editable: true,
              type: 'select',
              render: (value: any, record: any) => {
                const colorText = getStatusColor(value);

                return (
                  <div
                    style={{
                      fontWeight: 700,
                      color: colorText.color,
                      cursor: 'pointer'
                    }}
                  >
                    {colorText.text}{' '}
                    {value === 'rejected' && record?.comment && (
                      <span className="customComment"> - {record.comment}</span>
                    )}
                  </div>
                );
              }
            }
          ]
        : []),
      ...(hasUserRole(UserRole.Checker_Role) || hasUserRole(UserRole.Both_role)
        ? [
            {
              title: makeCheckKeyLabel.STATUS.label,
              dataIndex: 'status',
              editable: true,
              type: 'select',

              render: (value: any, record: any) => {
                const colorText = getStatusColor(value);

                return (
                  <Tag
                    onClick={() => {
                      if (shouldBlockReadOnly()) {
                        usePlatformStore
                          .getState()
                          .setOpenOnFreeTrialMessageModel(true);

                        return;
                      }
                      setShowModelInfo(true);
                      setEditData(record);
                      setIsEdit(true);
                    }}
                    color={colorText.color}
                    style={{
                      fontWeight: 700,
                      cursor: 'pointer'
                    }}
                  >
                    {colorText.text}
                  </Tag>
                );
              }
            }
          ]
        : []),
      ...(hasUserRole(UserRole.Checker_Role) || hasUserRole(UserRole.Both_role)
        ? [
            {
              title: FullInfo.title,
              dataIndex: 'FullInfo',
              editable: true,
              type: 'select',
              render: (_: any, record: any) => {
                return (
                  <Button
                    onClick={() => {
                      setShowModelInfo(true);
                      setIsEdit(true);
                      setEditData(record);
                    }}
                    shape="circle"
                    style={{
                      marginRight: 16,
                      cursor: 'pointer',
                      color: '#435B37',
                      background: '#F5FBF3',
                      border: 0
                    }}
                  >
                    <ExclamationOutlined />
                  </Button>
                );
              }
            }
          ]
        : []),
      ...(hasUserRole(UserRole.Maker_Role) || hasUserRole(UserRole.Both_role)
        ? [
            {
              title: Title.actionTitle,
              dataIndex: 'operation',
              type: '' as const,
              fixed: 'right' as const,
              width: '200px',
              render: (value: any, record: any) =>
                dataSource.length >= 1 ? (
                  <ActionsButton
                    record={record}
                    setShowModel={setShowModel}
                    setEditData={setEditData}
                    setIsEdit={setIsEdit}
                    handleDelete={handleDelete}
                  />
                ) : null
            }
          ]
        : [])
    ];
  }, [dataSource]);

  return (
    <>
      <div>
        <TableTitleHeader
          title="Emission Info"
          filter={{facilityId, selectedYear}}
          addButton={{
            setShowModel,
            setIsEdit,
            buttonTitle: 'Add Fuel'
          }}
          sampleDownload={{href: SampleExcel.fuelByRefri}}
          jobs={{setShowJobs, uploadType: uploadTypes.RefrigeratorUtility}}
          deleteButton={{selectedRowKeys, handleDelete}}
          refresh={{setRefresh}}
          tooltip={InformativeText.IP.refri}
          shouldEdit={
            hasUserRole(UserRole.Maker_Role) || hasUserRole(UserRole.Both_role)
          }
        />
        <JobsModal
          open={showJobs}
          onCancel={() => {
            setShowJobs(false);
            setRefresh(true);
          }}
          type={uploadTypes.RefrigeratorUtility}
          details={`${facilityId}/${selectedYear}`}
        />
        <TableAnt
          // getPopupContainer={(triggerNode) =>
          //   triggerNode.closest(
          //     '.ant-modal, .ant-drawer, [style*="position"]'
          //   ) as HTMLElement
          // }
          rowSelection={
            hasUserRole(UserRole.Maker_Role) || hasUserRole(UserRole.Both_role)
              ? {
                  type: 'checkbox',
                  selectedRowKeys,
                  getCheckboxProps: (record: any) => ({
                    disabled: record.status === statusEm.ACCEPTED
                  }),
                  onChange: (
                    selectedKey: React.Key[],
                    selectedRow: DataType[]
                  ) => {
                    setSelectedRowKeys(
                      selectedRow.map((item: any) => {
                        return item?.status !== statusEm.ACCEPTED
                          ? item._id
                          : null;
                      })
                    );
                  }
                }
              : undefined
          }
          rowKey="_id"
          dataSource={dataSource}
          columns={columns as any}
          scroll={{x: 'auto'}}
          loading={{
            indicator: <Loader />,
            spinning: allJSON ? isRefresh : true
          }}
        />
        <DrawerForm
          open={showModel}
          onCancel={() => {
            setShowModel(false);
          }}
          setRefresh={setRefresh}
          data={isEdit ? editData : undefined}
          FormComponent={<RefriForm />}
          API={fugitiveAPI}
          idKey={`${facilityId}/${selectedYear}`}
          table={true}
          fullScreen={true}
          stepsTitle={[
            'Configure Details',
            'Emission Details',
            'Quantity Details'
          ]}
          formPreview={fugitiveKeyLabel}
        />
        <DisplayModal
          title={openDisplayModalType.title}
          open={openDisplayModal}
          onCancel={() => {
            setOpenDisplayModal(false);
          }}
          displayComponent={
            <TimeFrameDataTooltip mainData={openDisplayModalData} />
          }
        />
      </div>
      <DrawerForm
        open={showModelInfo}
        onCancel={() => {
          setShowModelInfo(false);
        }}
        setRefresh={setRefresh}
        title="All Data"
        data={isEdit ? editData : undefined}
        FormComponent={
          <AllDataInfo formData={editData} formPreview={fugitiveKeyLabel} />
        }
        API={fugitiveAPI}
        isChecker={true}
        isAction={false}
        stepsTitle={['Status & Comments']}
        // formPreview={fugitiveKeyLabel}
      />
    </>
  );
};

export default FugitiveEmission;
